import { DOC_TYPE_REQUIRED, DossierJsonldRead } from '@europrocurement/l2d-domain';
import DocumentContext from '@europrocurement/l2d-modules/modules/Dossiers/providers/DocumentContext';

import useDossierFile from '@europrocurement/l2d-modules/modules/Dossiers/hooks/useDossierFile';
import { DisplayedDocument } from '@europrocurement/l2d-modules/modules/Dossiers/providers/types';
import { Box } from '@mui/system';
import React, { useContext, useEffect, useState } from 'react';
import RequiredDocumentsList from '@europrocurement/l2d-modules/modules/Dossiers/components/detail/RequiredDocumentsList/RequiredDocumentsList';
import RequiredDocumentUploader from '@europrocurement/l2d-modules/modules/Dossiers/components/detail/RequiredDocumentUploader/RequiredDocumentUploader';

interface DocToSendProps {
    dossier: DossierJsonldRead;
}

export const DocToSend: React.FunctionComponent<DocToSendProps> = function ({ dossier }) {
    const [uploadingAdditionalDocument, setUploadingAdditionalDocument] = useState<boolean>(false);
    const [listItems, setListItems] = useState<Array<DisplayedDocument>>([]);
    const {
        documents,
        fichiers,
        getPrescriberDocuments,
        getPrescriberAdditionalDocuments,
        setDossierFromParcours,
    } = useContext(DocumentContext);

    useEffect(() => {
        setDossierFromParcours(dossier);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dossier]);

    useEffect(() => {
        const items = [...getPrescriberDocuments(), ...getPrescriberAdditionalDocuments()].map(
            (item) => ({
                ...item,
                movable: false,
            }),
        );

        setListItems(items);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [documents, fichiers]);

    const { handleAddFile, handleRemoveFile, handleShow, handleDownload, handleAdditionalUploads } =
        useDossierFile({
            listItems,
            setListItems,
            setUploadingAdditionalDocument,
            typeDoc: DOC_TYPE_REQUIRED,
            dossierProps: dossier,
        });

    return (
        <Box sx={{ display: 'grid', gap: '8px 0' }}>
            <RequiredDocumentsList
                documents={listItems}
                onUpload={handleAddFile}
                onDeletion={handleRemoveFile}
                onDownload={handleDownload}
                onShow={handleShow}
                onMove={() => {}}
            />
            <RequiredDocumentUploader
                uploading={uploadingAdditionalDocument}
                onChange={handleAdditionalUploads}
            />
        </Box>
    );
};

export default DocToSend;
